import {getFlatInterestRemaining, getPaymentSchedule, getRemainingPayments} from "./financeUtils";
import {NotificationManager} from "react-notifications";
import axios from "axios";
import {createSetDataFreshAction} from "./actions/dataActions";

export function getPartCustomerCost(part, customer, appDefaults) {
  if (part.cost && !part.cost_override) {
    return customer && (customer.parts_markup || customer.parts_markup === 0) ? (1 * part.cost + part.cost * (customer.parts_markup / 100)).toFixed(
      2
    ) : (1 * part.cost + part.cost * (appDefaults.default_parts_markup / 100)).toFixed(
      2
    )
  }
  return (1 * part.customer_cost || 0).toFixed(2);
}

export function getStatus(job, itemType) {
  const startField =
    itemType === "Job" ? "workshop_date" : "provisional_start_date";
  const approvedField =
    itemType === "Job" ? "approved" : "ready_for_customer_invoice";

  let status =
    new Date(job[startField]) < new Date() ? "In Progress" : "Not Started";

  if (itemType === "Job") {
    if (job.status === "RETURNED_FROM_WORKSHOP") {
      status = "RETURNED FROM WORKSHOP";
    } else if (job.status === "READY_FOR_COLLECTION") {
      status = "READY FOR COLLECTION";
    } else if (job.status === "COLLECTED") {
      status = "COLLECTED"
    }
  }

  const approved = !!job[approvedField];
  return {status, approved};
}

export function getSTRates(rental){
  // Takes a rental object
  // Calculates the effective rate for each day range
  // Checks if the rate would be applied and for any discounts
  let returnObj = {
    day1_2_rate: 0,
    day3_6_rate: 0,
    day7_27_rate: 0,
    day_28_plus_rate: 0
  }
  if(!!rental && rental.rate_card){
    if(rental.apply_day1_2_rate){
      let rate = rental.rate_card.day1_2_rate;
      // Discount is stored as a whole number
      let discount = (rental.day1_2_discount / 100);

      returnObj.day1_2_rate = (1-discount) * rate;
      returnObj.day1_2_rate = (Math.round((returnObj.day1_2_rate * 100))) / 100

    }
    if(rental.apply_day3_6_rate){
      let rate = rental.rate_card.day3_6_rate;
      // Discount is stored as a whole number
      let discount = (rental.day_3_6_discount / 100);

      returnObj.day3_6_rate = (1-discount) * rate;
      returnObj.day3_6_rate = (Math.round((returnObj.day3_6_rate * 100))) / 100

    }
    if(rental.apply_day7_27_rate){
      let rate = rental.rate_card.day7_27_rate;
      // Discount is stored as a whole number
      let discount = (rental.day_7_27_discount / 100);

      returnObj.day7_27_rate = (1-discount) * rate;
      returnObj.day7_27_rate = (Math.round((returnObj.day7_27_rate * 100))) / 100

    }
    if(rental.apply_day_28_plus_rate){
      let rate = rental.rate_card.day_28_plus_rate;
      // Discount is stored as a whole number
      let discount = (rental.day_28_plus_discount / 100);

      returnObj.day_28_plus_rate = (1-discount) * rate;
      returnObj.day_28_plus_rate = (Math.round((returnObj.day_28_plus_rate * 100))) / 100

    }
  }

  return returnObj;


}

export function getEarliestSTRateInfo(rental){
  // Takes a rental
  // Returns the rate (with discount), insurance and Admin Fee that will occur earliest
  let rates = getSTRates(rental);
  let returnObj = {
    rate: 0,
    ins: 0,
    admin: 0
  }
  // loop through rates and stop at the first non 0 value (the earliest one we are applying)
  for (const [key, value] of Object.entries(rates)){
    if(value > 0){
      returnObj.rate=value
      if(rental.apply_insurance) {
        returnObj.ins = Math.round(((value * rental.rate_card.insurance_perc) * 100)) / 100;
      }
      if(rental.apply_admin_fee) {
        returnObj.admin = Math.round(((value * rental.rate_card.admin_perc) * 100)) / 100;
      }
      break
    }
  }

  return returnObj
}


export function getNext15K(startMileage, yearlyMiles){
  if(!startMileage || !yearlyMiles){
    return 0
  }
  // Use variable so its easier to change than individual instances of number
  let mileageGoal = 15000;

  let goalInstances = startMileage / mileageGoal;
  let dailyMiles = yearlyMiles / 365;

  // Get how many times we have passed the mileage goal
  goalInstances = Math.floor(goalInstances);
  // Step forward so we can figure out when the next goad is
  goalInstances +=1
  let newGoal = goalInstances * mileageGoal;

  // Figure out how many miles till next goal
  let mileageDiff = newGoal - startMileage;
  // Work out how many days it will take to get there
  let days = mileageDiff / dailyMiles;

  // We only want to deal in whole days
  days = (Math.round((days * 100))) / 100
  days = Math.floor(days);

  return days
}

export function getPartCustomerEstimatedCost(part, customer, appDefaults) {
  if (part.estimated_cost && !part.cost_override) {
    return customer && (customer.parts_markup || customer.parts_markup === 0) ? (1 * part.estimated_cost + part.estimated_cost * (customer.parts_markup / 100)).toFixed(
      2
    ) : (1 * part.estimated_cost + part.estimated_cost * (appDefaults.default_parts_markup / 100)).toFixed(
      2
    )
  }
  return (1 * part.estimated_customer_cost || 0).toFixed(2);
}

export function getWorkItemCustomerCost(vehicle, supplier, newWorkItem, customer, lcv_job) {
  if (vehicle.type && vehicle.type.special_labour_rate) {
    newWorkItem.customer_labour_cost = (
      newWorkItem.labour_hours * vehicle.type.special_labour_rate
    ).toFixed(2);
  }
  if (customer && customer.labour_rate_markup) {
    newWorkItem.customer_labour_cost = (
      (1 * newWorkItem.customer_labour_cost) * (1 + (customer.labour_rate_markup / 100))
    ).toFixed(2);
  }

  if (supplier) {
    let supplier_labour_charge = lcv_job && supplier.lcv_rate ? supplier.lcv_rate : supplier.supplier_labour_charge
    if (supplier && supplier.labour_rate_affected_by_customer_markup) {
      newWorkItem.labour_cost = (
        (newWorkItem.labour_hours * supplier_labour_charge) * (1 + (customer.labour_rate_markup / 100))
      ).toFixed(2);
    } else if (supplier && supplier_labour_charge) {
      newWorkItem.labour_cost = (
        newWorkItem.labour_hours * supplier_labour_charge
      ).toFixed(2);
    }
    return newWorkItem;
  }
  else{
    return newWorkItem;
  }
}

export function getWorkItemEstimateCustomerCost(vehicle, supplier, newWorkItem, customer, defaultLabourQuoteRate) {
  if (vehicle.type && vehicle.type.special_labour_rate) {
    newWorkItem.estimated_customer_labour_cost = (
      newWorkItem.estimated_labour_hours *
      vehicle.type.special_labour_rate
    ).toFixed(2);
  }
  if (customer && customer.labour_rate_markup) {
    newWorkItem.estimated_customer_labour_cost = (
      (1 * newWorkItem.estimated_customer_labour_cost) * (1 + (customer.labour_rate_markup / 100))
    ).toFixed(2);
  }
  if (defaultLabourQuoteRate) {
    newWorkItem.estimated_labour_cost = (
      newWorkItem.estimated_labour_hours * defaultLabourQuoteRate
    ).toFixed(2);
  }
  if (customer && customer.labour_rate_markup) {
    newWorkItem.estimated_labour_cost = (
      (1 * newWorkItem.estimated_labour_cost) * (1 + (customer.labour_rate_markup / 100))
    ).toFixed(2)
  }
  return newWorkItem;
}

export function getDaysInYear(year){
    // takes a year (Int)
    // returns how many days are in that year
    let feb29 = new Date(year, 1 , 29);
    if(feb29.getDate() === 29){
        // the 29th of Feb exists so it is a leap year
        return 366
    }
    else{
        return 365
    }
}

export function getDaysInYearDate(date){
    // takes a date object
    // returns how many days are in that year

    let year = date.getFullYear();
    return getDaysInYear(year);
}

export function getQueryString(params) {
  let keys = Object.keys(params);

  if (params && keys.length) {
    keys.forEach(key => {
      if (typeof params[key] === "undefined" || params[key] === null) {
        delete params[key];
      }
    });
    return (
      "?" +
      Object.keys(params)
        .map(key => key + "=" + encodeURIComponent(params[key]))
        .join("&")
    );
  }
  return "";
}

export function formatDate(date) {
  let day = "" + date.getDate();
  let month = "" + (date.getMonth() + 1);
  let year = "" + date.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

export function readableDate(date) {
  if (!date) return "";
  let dateObject = toDate(date);
  let dd = dateObject.getDate();
  let mm = dateObject.getMonth() + 1; //January is 0!

  let yyyy = dateObject.getFullYear();
  if (dd < 10) {
    dd = "0" + dd;
  }
  if (mm < 10) {
    mm = "0" + mm;
  }

  return dd + "/" + mm + "/" + yyyy;
}

export function formatDateTime(date){
    // all date objects in js are actually date time objects
    let datePart = readableDate(formatDate(date));
    let hour = date.getHours();
    let min = date.getMinutes()

    let timePart = hour+":"+min;

    return datePart+" "+timePart
}

export const toDate = dateStr => {
  const [year, month, day] = dateStr.split("-");
  return new Date(year, month - 1, day);
};
export const getFullMonthFromInt = monthInt => {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return months[monthInt-1];
}
export const getFullMonth = date => {
  let month = date.getMonth()-1; //Js months are 0-11 but dates in Js are 1-12
  return getFullMonthFromInt(month);
}

export const daysInMonth = (month, year) => {
  return new Date(year, month, 0).getDate();
}
function blankLineItem(description){

  return {
    Description: description,
    Quantity: 1,
    UnitAmount: 0,
    AccountCode: null,
    DiscountRate: 0,
    TrackingCategories: []
  }

}


function createCashSaleLine(cashSale){
  let description = "Cash Sale Details:"
  if(cashSale.name){
    description += `\nName: ${cashSale.name}`;
  }

  if(cashSale.phone){
    description += `\nPhone Number: ${cashSale.phone}`;
  }

  if(cashSale.email){
    description += `\nEmail: ${cashSale.email}`;
  }

  if(cashSale.address){
    description += `\nAddress: ${cashSale.address}`;
  }

  return description;
}

function saleInvoiceLineItem(data, source){
  // Takes 1 line items worth of data
  // Returns an object in the correct format

  let unitAmount;
  let description;
  let accountCode;
  let trackingCategories = [];
  let quantity = 1;
  if(source === "IN"){
    // Invoice
    // No VAT and VAT amounts need to be separate line items
    unitAmount = data.amount;
    description = data.description;
    accountCode = data.nominal_code.code;
    let cat = {
      Name: data.tracking_option.category.name,
      Option: data.tracking_option.name
    }
    trackingCategories.push(cat);
    if(data.rental && data.rental.id){
        // if the invoice is a hire invoice
        // quantity should be pulled from the invoice
        quantity = data.quantity;
    }
  }
  else if(source === "TRI"){
    // TRI - Income, TRE - Expense
    unitAmount = data.invoice_amount;
    description = data.description;
    accountCode = data.nominal_code.code;
    let cat = {
      Name: data.tracking_option.category.name,
      Option: data.tracking_option.name
    }
    trackingCategories.push(cat);
  }
  else if(source === "PA"){
    // Customer invoicing
    unitAmount = data.customer_cost;
    description = data.name;
    accountCode = data.customer_nominal_code.code;
    let cat = {
      Name: data.customer_tracking_option.category.name,
      Option: data.customer_tracking_option.name
    }
    trackingCategories.push(cat);
  }
  else if(source === "WO"){
    // Customer invoicing
    unitAmount = data.customer_labour_cost;
    description = data.description;
    accountCode = data.customer_nominal_code.code;
    let cat = {
      Name: data.customer_tracking_option.category.name,
      Option: data.customer_tracking_option.name
    }
    trackingCategories.push(cat);
  }
  else if(source === "PAID"){
    let amountPaid = (Math.round(data.paid_amount * 100)) / 100;
    if(amountPaid) {
        description = `PAID £${amountPaid}`
    }
    else{
        description = "PAID"
    }
    unitAmount = 0;
  }

  return {
    Description: description,
    Quantity: quantity,
    UnitAmount: unitAmount,
    AccountCode: accountCode,
    DiscountRate: 0,
    TrackingCategories: trackingCategories
  }

}
function saleInvoice(data, source){
  // Data is an array of objects all part of the same invoice
  let ref;
  let dueDate = new Date();
  let invoiceDate = formatDate(new Date());
  let contact;
  let lineItems = [];
  let deptCode;
  // List of work items come in
  // this list should be to only 1 customer (1 invoice)
  if(source === "J"){
    // when a workshop sales invoice is being processed it could be for either a quote or a job
    // if the first item in the array has a quote id attached then it is a quote that is being processed
    let customer1Data = data.filter((item) => item.chargeable === false);
    let customer2Data = data.filter((item) => item.chargeable === true);
    if(customer1Data.length > 0){
      var customer1Invoice = {};
      invoiceDate = customer1Data[0].customer_invoice_date;
      customer1Invoice.InvoiceDate = invoiceDate;
      customer1Invoice.ContactName = customer1Data[0].customer + "-" + customer1Data[0].customer_workshop_account;
      if(customer1Data[0].quote){
        customer1Invoice.InvoiceRef = "Q1-"+customer1Data[0].quote + "-" + customer1Data[0].vehicle_registration;
      }
      else {
        customer1Invoice.InvoiceRef = "J1-"+customer1Data[0].job + "-" + customer1Data[0].vehicle_registration;
      }
      dueDate.setDate(dueDate.getDate() + customer1Data[0].customer_payment_terms) // Adds days to today to calculate dueDate
      customer1Invoice.DueDate = dueDate;
      customer1Invoice.XeroDept = getDeptCode(customer1Data[0].department); // All work items on the same job share a department
      let lineItems = []
      // a line item needs to be pushed with cash sale details if there are any
      // all work items will have both customer 1 and customer 2 cash sale details if any are present
      if(customer1Data[0].customer1_cash_sale_details){
        let cashSale = customer1Data[0].customer1_cash_sale_details;
        let description = createCashSaleLine(cashSale);
        lineItems.push(blankLineItem(description));
      }
      customer1Data.forEach(item => {
        lineItems.push(saleInvoiceLineItem(item, "WO"));
        item.parts.forEach(part => {
          lineItems.push(saleInvoiceLineItem(part, "PA"));
        });
      });
      if(customer1Data[0].customer_paid_amount > 0){
        lineItems.push(saleInvoiceLineItem({paid_amount: customer1Data[0].customer_paid_amount}, "PAID"));
      }
      customer1Invoice.LineItems = lineItems
    }
    if(customer2Data.length > 0){
      var customer2Invoice = {}
      invoiceDate = customer2Data[0].customer_invoice_date;
      customer2Invoice.InvoiceDate = invoiceDate;
      customer2Invoice.ContactName = customer2Data[0].customer2 + "-" + customer2Data[0].customer2_workshop_account;
      if(customer2Data[0].quote){
        customer2Invoice.InvoiceRef = "Q2-"+customer2Data[0].quote + "-" + customer2Data[0].vehicle_registration;
      }
      else {
        customer2Invoice.InvoiceRef = "J2-"+customer2Data[0].job + "-" + customer2Data[0].vehicle_registration;
      }
      dueDate.setDate(dueDate.getDate() + customer2Data[0].customer2_payment_terms) // Adds days to today to calculate dueDate
      customer2Invoice.DueDate = dueDate;
      customer2Invoice.XeroDept = getDeptCode(customer2Data[0].department); // All work items on the same job share a department
      let lineItems = []
      // a line item needs to be pushed with cash sale details if there are any
      // all work items will have both customer 1 and customer 2 cash sale detials if any are present
      if(customer2Data[0].customer2_cash_sale_details){
        let cashSale = customer2Data[0].customer2_cash_sale_details;
        let description = createCashSaleLine(cashSale);
        lineItems.push(blankLineItem(description));
      }
      customer2Data.forEach(item => {
        lineItems.push(saleInvoiceLineItem(item, "WO"));
        item.parts.forEach(part => {
          lineItems.push(saleInvoiceLineItem(part, "PA"));
        });
      });
      if(customer2Data[0].customer_paid_amount > 0){
        lineItems.push(saleInvoiceLineItem({paid_amount: customer2Data[0].customer_paid_amount}, "PAID"));
      }
      customer2Invoice.LineItems = lineItems
    }
    //filter array data down to customer 1 and customer 2 (chargeable)
    //pass arrays to generate line items
    // can generate multiple invoices how handle?
    return [customer1Invoice, customer2Invoice]
  }
  else {
    if(source === "TRI"){
      // get account from transaction category
      let account = data[0].customer_account
      contact = data[0].contact.display_name+"-"+data[0].contact[account];
      deptCode = getDeptCode(data[0].department);
      invoiceDate = data[0].invoice_date
      dueDate.setDate(dueDate.getDate() + data[0].contact.payment_term_days) // Adds days to today to calculate dueDate
      ref = "TR-"+data[0].id; // If data is an income array should only be length 1
    }
    if(source === "IN") {
      let account;
      if(data[0].customer.is_cash_sale){
        if(data[0].cash_sale_details){
          let cashSale = data[0].cash_sale_details
          let description = createCashSaleLine(cashSale)
          lineItems.push(blankLineItem(description));
        }
      }

      if (data[0].finance_agreement) {
        account = data[0].customer.sale_account_code
      }
      else if (data[0].movement){
        if(data[0].movement.rental && !data[0].movement_performer_flag){
          // any movements done on a contact should be charged to the hire account
          // only the charge to the hire customer should use the hire account code
          // Any invoices done on behalf of the hire company should be charged under the selected code
          account = data[0].customer['hire_account_code'];
        }
        else {
          account = data[0].customer[data[0].customer_account]
        }
      }
      else if (data[0].part_order){
        account = data[0].customer.part_account_code
        // should list each part as a line item
        data[0].part_order.parts.forEach(part => {
          // figure out which nominal code is present
          let partData = {...part, customer_tracking_option: data[0].tracking_option}
          if(data[0].vat_nominal_code){
              partData.customer_nominal_code = data[0].vat_nominal_code;
          }
          else if(data[0].no_vat_nominal_code){
              partData.customer_nominal_code = data[0].no_vat_nominal_code
          }
          // PART WILL EVENVTUALLY ALLWAYS HAVE CUSTOMER TRACKING OPTION (CHANGE AFTER THAT IS THE CASE)
          lineItems.push(saleInvoiceLineItem(partData, "PA"))
        });
        if(data[0].customer_paid_amount > 0){
          lineItems.push(saleInvoiceLineItem({paid_amount: data[0].customer_paid_amount}, "PAID"));
        }
      }
      else if (data[0].rental){
        account = data[0].customer.hire_account_code
      }
      contact = data[0].customer.display_name + "-" + account;
      dueDate.setDate(dueDate.getDate() + data[0].customer.payment_term_days) // Adds days to today to calculate dueDate
      ref = "IN-"+data[0].id;
      deptCode = getDeptCode(data[0].department);
      invoiceDate = data[0].invoice_date;

      if(data[0].movement){
        if(data[0].movement.order_number){
          // Lazy should be moved above
          ref = ref+"-"+data[0].movement.order_number;
        }
        ref = ref+"-"+data[0].movement.id;
      }
    }
    data.forEach(item => {
      if (source === "TRI") {
        lineItems.push(saleInvoiceLineItem(item, source));
        if(item.customer_paid_amount > 0){
          lineItems.push(saleInvoiceLineItem({paid_amount: item.customer_paid_amount}, "PAID"))
        }
      }
      if(source === "IN" && !(!!data[0].part_order)){
        // separate nominal for no vat and vat amount?
        // Been told that all items need to go through to Xero in some capactity even if 0 cost
        // use vat nominal
        lineItems.push(saleInvoiceLineItem({...item, nominal_code: item.vat_nominal_code}, source));
        if(item.no_vat_amount > 0){
          // use no vat nominal
          lineItems.push(saleInvoiceLineItem({...item, amount: item.no_vat_amount, nominal_code: item.no_vat_nominal_code}, source));
        }
        if(data[0].customer_paid_amount > 0){
          lineItems.push(saleInvoiceLineItem({paid_amount: data[0].customer_paid_amount}, "PAID"));
        }
      }
    });
    return {
      XeroDept: deptCode,
      InvoiceDate: invoiceDate,
      InvoiceRef: ref,
      Status: "DRAFT",
      DueDate: formatDate(dueDate),
      ContactName: contact,
      LineItems: lineItems
    }
  }
}

function purchaseInvoiceLineItem(data, source){
  let unitAmount;
  let description;
  let accountCode;
  let trackingCategories = [];

  if(source === "PA"){
    unitAmount = data.cost;
    description = data.name;
    accountCode = data.supplier_nominal_code.code;
    let cat = {
      Name: data.supplier_tracking_option.category.name,
      Option: data.supplier_tracking_option.name
    }
    trackingCategories.push(cat);
  }
  else if(source === "WO"){
    unitAmount = data.labour_cost;
    description = data.description;
    accountCode = data.supplier_nominal_code.code;
    let cat = {
      Name: data.supplier_tracking_option.category.name,
      Option: data.supplier_tracking_option.name
    }
    trackingCategories.push(cat);
  }
  else if(source === "TRE"){
    unitAmount = data.invoice_amount;
    description = data.description;
    accountCode = data.nominal_code.code;
    let cat = {
      Name: data.tracking_option.category.name,
      Option: data.tracking_option.name
    }
    trackingCategories.push(cat);
  }

  return {
    Description: description,
    Quantity: 1,
    UnitAmount: unitAmount,
    AccountCode: accountCode,
    DiscountRate: 0,
    TrackingCategories: trackingCategories
  }
}
function getDeptCode(department){
  if(department && department.id){
    if(department.name === "DIRECT VAN HIRE"){
      return `VH-${department.id}`
    }
    else if(department.name === "RAPID FIT"  || department.name === "MAXUS PARTS DIRECT"){
      return `RF-5` // Maxus parts direct does not have the correct id so we hard code it
    }
    else if(department.name === "VAN SALES DIRECT"){
      return `VS-${department.id}`
    }
    else if(department.name === "DVR TA DIRECT VEHICLE RECOVERY"){
      return `DR-${department.id}`
    }
  }
}
function purchaseInvoice(data, source){
  // Data is an array of objects all part of the same invoice
  let ref;
  let invoiceNumber;
  let invoiceDate = formatDate(new Date()); // Default to today if no invoice date is given
  let dueDate = new Date(); // Will use a field set on contact MERGE MASTER FOR SUPPLIER DUE DATE
  let contact;
  let lineItems = [];
  let departmentCode;
  // get first item in data
  // set ref based on source to invoice number
  if(source === "PA"){
    invoiceNumber = data[0].part_invoice_number;
    contact = data[0].supplier.display_name;
    ref = "PA-"+data[0].id;
    departmentCode = getDeptCode(data[0].department);
    // when we approve van parts direct parts that are not postage we actually need to send it through to rapid fit
    // we need to filter all van parts direct postage parts out of the data

    if(data[0].department && data[0].department.id === 9){
      // if we are handling VAN PARTS DIRECT parts then we dont want the postage going through to rapid fit
      let temp = data.filter(item => item.is_postage === false);
      if(temp.length > 0){ // this handles errors being thrown later as dataa becomes empty
        // we do this this way instead of adding it to getDeptCode because we do not want VAN PARTS DIRECT to always be treated as RF
        departmentCode = "RF-5"
        data = temp
        dueDate = expenseDueDate(data[0], "invoice_date", "supplier");
      }
    }

    invoiceDate = data[0].invoice_date
  }
  else if(source === "WO"){
    invoiceNumber = data[0].job_workshop_invoice_number;
    contact = data[0].workshop;
    ref = "WO-"+data[0].id;
    if(data[0].vehicle_registration){
      ref = ref + "-" + data[0].vehicle_registration
    }
    departmentCode = getDeptCode(data[0].department)
    dueDate = expenseDueDate(data[0], "workshop_invoice_date", "workshop_details");
    invoiceDate = data[0].workshop_invoice_date
    // work items can also have parts as line items
  }
  else if (source === "TRE"){
    // Transaction Expense
    invoiceNumber = data[0].invoice_number;
    contact = data[0].contact.display_name;
    ref = "TR-"+data[0].id;
    departmentCode = getDeptCode(data[0].department)
    dueDate = expenseDueDate(data[0], "invoice_date", "contact");
    invoiceDate = data[0].invoice_date;
  }
  data.forEach((item, index) => {
    lineItems.push(purchaseInvoiceLineItem(item, source));

    if(source === "WO" && item.parts && item.parts.length){
      let workshopParts = item.parts.filter(part => part.supplier.id === item.workshop_id);
      if(workshopParts.length > 0) {
        workshopParts.forEach((item) => {
          lineItems.push(purchaseInvoiceLineItem(item, "PA"));
        });
      }
    }
  })
  return {
    XeroDept: departmentCode,
    AppReference: ref,
    InvoiceNumber: invoiceNumber,
    InvoiceDate: invoiceDate,
    Status: "DRAFT",
    DueDate: formatDate(dueDate),
    ContactName: contact,
    LineItems: lineItems
  }
}

function contactData(data, accountCode, source){
  let suffix = source === "CC" ? "-"+accountCode : "";
  let contact = {
    Name: data.display_name+suffix,
    FirstName: data.company_name,
    LastName: "",
    Email: data.company_email,
    AccountNumber: data.display_name+suffix,
    Addresses: [
      {
        AddressType: "STREET",
        AddressLine1: data.address_line1,
        AddressLine2: "",
        AddressLin3: "",
        AddressLine4: "",
        City: data.town,
        PostalCode: data.postcode,
        Region: data.region,
        Country: data.country,
      }
    ],
    Phones: [
       {
        PhoneType: data.company_phone_type,
        PhoneNumber: data.company_phone,
        PhoneAreaCode: data.company_phone_area_code,
        PhoneCountryCode: data.company_phone_country_code
      }
    ]
  }

  return contact;
}

function formatContacts(data, source){
  let codes = ["hire_account_code", "loan_account_code", "sale_account_code", "deposit_account_code", "workshop_account_code", 'part_account_code', 'court_account_code', 'movement_account_code'];
  let contacts = []
  if(source === "CC") {
    codes.forEach(code => {
      if(data[code] !== "" && data[code] != null) {
        contacts.push(contactData(data, data[code], source));
      }
    });
  }
  else{
    // SP source should skip accountCode req
    contacts.push(contactData(data, "", source))
  }
  return contacts
}

function saleCreditNoteLineItem(data, source){
  let description;
  let amount;
  let accountCode;
  if(source === "CN"){
    if(data.invoice){
      description = data.description
    }
    else if(data.transaction && data.transaction.type === "IN"){
      //only income transactions are sales
      description = data.description;
    }
    else if(data.part){
      description = data.description;
    }
    else if(data.work){
      description = data.description
    }
    accountCode = data.nominal_code.code;
    amount = data.amount
  }

  return {
    Description: description,
    Quantity: 1,
    UnitAmount: amount,
    AccountCode: accountCode
  }

}

function saleCreditNote(data, source){
  let ref;
  let date = new Date();
  let contact;
  let invoiceNumber
  let lineItems = [];
  let deptCode;

  if(source === "CN"){
    if(data[0].invoice){
      let accountCode;
      // use vat and no vat nominal codes
      if(data[0].invoice.finance_agreement){
        accountCode = data[0].invoice.customer.sale_account_code
      }
      else if(data[0].invoice.movement){
        accountCode = data[0].invoice.customer[data[0].invoice.customer_account]
      }
      else if(data[0].invoice.part_order){
          accountCode = data[0].invoice.customer.part_account_code;
      }
      else if(data[0].invoice.rental){
          accountCode = data[0].invoice.customer.hire_account_code;
      }
      contact = data[0].invoice.customer.display_name + "-" + accountCode
    }
    else if(data[0].transaction && data[0].transaction.type === "IN"){
      let account = data[0].transaction.customer_account
      contact = data[0].transaction.contact.display_name+ "-" + data[0].transaction.contact[account]
    }

    else if(data[0].work){
      let accountCode;
      if(data[0].work.chargeable){
        accountCode = data[0].work.customer2_workshop_account;
        contact = data[0].work.customer2+"-"+accountCode
      }
      else if(!data[0].work.chargeable){
        accountCode = data[0].work.customer_workshop_account;
        contact = data[0].work.customer+"-"+accountCode;
      }
    }

    else if(data[0].part){
      let accountCode;
      if(data[0].part.work.chargeable){
        accountCode = data[0].part.part_customer.workshop_account_code;
        contact = data[0].part.part_customer.display_name+"-"+accountCode
      }
      else if(!data[0].part.work.chargeable){
        accountCode = data[0].part.part_customer.workshop_account_code;
        contact = data[0].part.part_customer.display_name+"-"+accountCode
      }
    }
    ref = "CN-"+data[0].id;
    deptCode = getDeptCode(data[0].department)

    data.forEach((item) => {
      if(source === "CN"){
        if(item.no_vat_amount > 0){
          lineItems.push(saleCreditNoteLineItem({...item, amount: item.no_vat_amount, nominal_code: item.no_vat_nominal_code}, source))
        }
      }
      lineItems.push(saleCreditNoteLineItem({...item, nominal_code: item.vat_nominal_code}, source))
    })


  }


  return {
    XeroDept: deptCode,
    InvoiceNumber: invoiceNumber,
    CreditNoteRef: ref,
    Date: formatDate(date),
    ContactName: contact,
    LineItems: lineItems
  }
}

function purchaseCreditNoteLineItem(data, source){
  let description;
  let amount;
  let accountCode;
  if(source === "CN"){
    if(data.transaction && data.transaction.type === "OUT"){
      description = data.description;
      accountCode = data.transaction.nominal_code.code;
      amount = data.amount
    }
  }
  if(source === "PA"){
    description = data.name;
    accountCode = data.supplier_nominal_code.code;
    amount = data.cost * -1;
  }
  if(source === "WO"){
    description = data.description;
    accountCode = data.supplier_nominal_code.code;
    amount = data.labour_cost * -1
  }

  return {
    Description: description,
    Quantity: 1,
    UnitAmount: amount,
    AccountCode: accountCode
  }
}

function purchaseCreditNote(data, source){

  let ref;
  let dueDate = new Date();
  let contact;
  let creditNumber;
  let lineItems = [];
  let deptCode;

  if(source === "CN"){
    //Expense Credit note
    if(data[0].transaction && data[0].transaction.type === "OUT"){
      contact = data[0].transaction.contact.display_name;
      creditNumber = data[0].credit_note_number;
      ref = "CN-"+data[0].id;
      deptCode = getDeptCode(data[0].department);
    }
  }
  else if(source === "WO"){
    contact = data[0].workshop;
    creditNumber = data[0].job_workshop_credit_number
    ref = "WO-"+data[0].id
    deptCode = getDeptCode(data[0].department);
  }
  else if(source === "PA"){
    contact = data[0].supplier.display_name;
    creditNumber = data[0].part_invoice_number;
    ref = "PA-"+data[0].id;
    deptCode = getDeptCode(data[0].department);
    if(data[0].department && data[0].department.id === 9){
      deptCode = "RF-5";
      data = data.filter(item => item.is_postage === false);
    }
  }
  data.forEach(item => {
    if(source === "CN" && item.no_vat_amount > 0){
      lineItems.push(purchaseCreditNoteLineItem({...item, amount: item.no_vat_amount, nominal_code: item.no_vat_nominal_code}, source));
    }
    lineItems.push(purchaseCreditNoteLineItem({...item, nominal_code: item.vat_nominal_code}, source));
    if(source === "WO"){
      item.parts.forEach(part => {
        lineItems.push(purchaseCreditNoteLineItem({...part, nominal_code: item.vat_nominal_code}, "PA"));
      })
    }
  })

  return {
    XeroDept: deptCode,
    AppReference: ref,
    InvoiceNumber: null,
    CreditNoteNumber: creditNumber,
    Date: formatDate(dueDate),
    ContactName: contact,
    LineItems: lineItems
  }
}

function nominalCode(data){
  return {
    Name: data['name'],
    Code: data['code'],
    Type: data['type'],
    TaxType: data['tax_type'],
    BankAccountNumber: data['bank_account_number'],
    Description: data['description'],
    EnablePaymentsToAccount: data['enable_payments_to_account'],
    ShowInExpenseClaims: data['show_in_expense_claims']
  }
}
function trackingOption(data){
  return {
    Name: data['name'],
    Status: data['status']
  }
}
function trackingCategory(data){
  // data should be a tracking category
  // data should have an options property
  let options = [];
  data.options.forEach(option => {
    options.push(trackingOption(option))
  })
  return {
    Name: data['name'],
    Status: data['status'],
    Options: options
  }
}

export function formatXeroData(data, source){
  // Data should be an array of objects all part of the same invoice
  // source should be 2-3 characters long e.g. PA, WO, JC1
  let purchaseInvoiceSources = ['PA', 'WO', 'TRE'];
  let saleInvoiceSources = ["IN", "TRI", "J"]; // J can be either customer 1 customer 2 or both
  let saleCreditSources = ["CNS"];
  let purchaseCreditSource = ['CNP', 'WOP', 'PAP'];
  let contactSources = ["CC", "SP"];
  if(purchaseInvoiceSources.includes(source)){
    let invoice = purchaseInvoice(data, source);
    return invoice;
  }
  else if(saleInvoiceSources.includes(source)){
    let invoice = saleInvoice(data, source);
    return invoice;
  }
  else if(saleCreditSources.includes(source)){
    let actualSource;
    if(source === "CNS"){
      actualSource = "CN"
    }
    let credit = saleCreditNote(data, actualSource);
    return credit;
  }
  else if(purchaseCreditSource.includes(source)){
    let actualSource;
    if(source === "CNP"){
      actualSource = "CN";
    }
    else if (source === "WOP"){
      actualSource = "WO"
    }
    else if(source === "PAP"){
      actualSource = "PA"
    }
    let credit = purchaseCreditNote(data, actualSource);
    return credit;
  }
  else if(contactSources.includes(source)){
    // Returns an array of contacts (1 for each code)
    let contacts = formatContacts(data, source);
    return contacts
  }
  else if(source === "TK"){
    // Tracking Category
    let category = trackingCategory(data)
    return category;
  }
  else if(source === "NC"){
    // Nominal Code
    let code = nominalCode(data);
    return code;
  }
}


export function sendXeroData(data, targetLocation){
  // Takes a single object and target endpoint
  // Sends data
  // Handles response?
  const targetUrl = `https://rentalsdirect4u.azurewebsites.net/api/${targetLocation}`
  // const targetUrl = "test://"
  let conf = {
    data: data,
    method: "post",
    url: targetUrl
  }

  return axios(conf).catch(err => {
  NotificationManager.error("There was an error sending data to xero");
    console.log(err);
  });
  //return new Promise();
}

export function convertXeroVat(vat){
  // Takes a xero vat code
  // Returns the interger percent value (20% = 20) etc.
  const map = {
    "INPUT2": 20,
    "OUTPUT2": 20,
    "RRINPUT": 5,
    "RROUTPUT": 5,
    "ECACQUISITIONS": 20,
    "ECZRACQUISITIONS": 0,
    "EXEMPTINPUT": 0,
    "EXEMPTOUTPUT": 0,
    "NONE": 0,
    "REVERSECHARGES": 20,
    "GSTONIMPORTS": 20,
    "ECZROUTPUT": 0,
    "ECZROUTPUTSERVICES": 0,
    "ECZRINPUT": 0,
    "ZERORATEDOUTPUT": 0,
    "ZERORATEDINPUT": 0
  }
  return map[vat]
}

export function addXeroVat(vat, amount){
  // Takes a xero vat code
  // returns and amount + the corrisponding VAT
  const map = {
    "INPUT2": 20,
    "OUTPUT2": 20,
    "RRINPUT": 5,
    "RROUTPUT": 5,
    "ECACQUISITIONS": 20,
    "ECZRACQUISITIONS": 0,
    "EXEMPTINPUT": 0,
    "EXEMPTOUTPUT": 0,
    "NONE": 0,
    "REVERSECHARGES": 0,
    "GSTONIMPORTS": 20,
    "ECZROUTPUT": 0,
    "ECZROUTPUTSERVICES": 0,
    "ECZRINPUT": 0,
    "ZERORATEDOUTPUT": 0,
    "ZERORATEDINPUT": 0
  }
  let vatPerc = 1 + (parseFloat(map[vat]) / 100);
  let total = amount * vatPerc;
  total = Math.round( (total * 100) ) / 100;
  return total;
}
export function compareVat(nominalCode, vat){
  // Takes a Nominal Code and a Xero Vat code
  // If they are equal return true
  // Else return false
  const map = {
    "20% (VAT on Expense)" : "INPUT2",
    "20% (VAT on Income)": "OUTPUT2",
    "5% (VAT on Expense)": "RRINPUT",
    "5% (VAT on Income)": "RROUTPUT",
    "EC Acquisitions (20%)": "ECACQUISITIONS",
    "EC Acquisitions (Zero Rated)": "ECZRACQUISITIONS",
    "Exempt Expenses": "EXEMPTINPUT",
    "Exempt Income": "EXEMPTOUTPUT",
    "No VAT": "NONE",
    "Reverse Charge Expenses (20%)": "REVERSECHARGES",
    "VAT on imports": "GSTONIMPORTS",
    "Zero Rated EC Goods Income": "ECZROUTPUT",
    "Zero Rated EC Services": "ECZROUTPUTSERVICES",
    "Zero Rated EC Expenses": "ECZRINPUT",
    "Zero Rated Income": "ZERORATEDOUTPUT",
    "Zero Rated Expense": "ZERORATEDINPUT"
  }
  if(nominalCode) {
    let nominalVat = map[nominalCode.tax_type];
    if (nominalVat === vat) {
      return true
    }
  }
  return false
}

export function depCreditLimit(contact, department){
    // takes a contact and department
    // returns the credit limit value from the contact for the correct department
    // defaults to 0
    let map = {
        1: 'credit_limit',
        4: "direct_van_hire_credit_limit",
        5: "rapid_fit_credit_limit",
        6: "van_sales_direct_credit_limit",
        7: "direct_vehicle_recovery_credit_limit"
    }
    let value = contact[map[department.id]]
    if(value !== undefined){
        return value
    }
    else {
        return 0
    }
}

export function sortRentals(rentals, startDate) {
  const monday = new Date(startDate);
  let day_rentals = [[], [], [], [], [], [], []];
  let day_totals = [0, 0, 0, 0, 0, 0, 0];
  for (var rental of rentals) {
    for (let i = 0; i < 7; i++) {
      var day = new Date(monday);
      day.setDate(monday.getDate() + i);
      if (
        new Date(rental.start_date) <= day &&
        day <= new Date(rental.finish_date)
      ) {
        day_totals[i] += rental.daily_cost;
        day_rentals[i].push(rental);
      }
    }
  }
  return {day_rentals: day_rentals, day_totals: day_totals};
}

export function getFirstDayOfMonth(selected) {
  let date = new Date(selected), y = date.getFullYear(), m = date.getMonth();
  return new Date(y, m, 1);
}

export function getLastDayOfMonth(selected) {
  let date = new Date(selected), y = date.getFullYear(), m = date.getMonth();
  return new Date(y, m + 1, 0);
}

export function getFirstDayOfWeek(selected) {
  let d = new Date(selected);
  let day = d.getDay(),
    diff = d.getDate() - day + (day === 0 ? -6 : 1);
  d.setDate(diff);

  return new Date(
    Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate())
  );
}

export function getLastDayOfWeek(start) {
  let finish_date = new Date(start);
  finish_date.setDate(finish_date.getDate() + 6);
  return finish_date;
}

export const getOutstandingBalance = (vehicle) => {
  let date;
  if (vehicle.finance_early_settlement_date) {
    date = new Date(vehicle.finance_early_settlement_date);
  } else {
    date = new Date(Date.now())
  }

  if (
    // !vehicle.finance_early_settlement_date &&
    (vehicle.end_date &&
      new Date(vehicle.end_date) > date
    ) || (
      vehicle.sp_capital_repayment_end_date && new Date(vehicle.sp_capital_repayment_end_date) > date
    )
  ) {
    let finalPayment = new Date(vehicle.end_date);
    if (vehicle.finance_type === "REGULAR" || vehicle.finance_type === 'LEASE_AGREEMENT') {
      let offset = 0;
      if(vehicle.freeze_start_date && vehicle.freeze_end_date && new Date(vehicle.freeze_start_date) <= date && date <= new Date(vehicle.freeze_end_date)){
        let freeze_start = new Date(vehicle.freeze_start_date);

        // Get months between freeze start and today
        offset = getMonthsBetween(date, freeze_start);
      }
      else if(vehicle.freeze_start_date && vehicle.freeze_end_date && date >= new Date(vehicle.freeze_end_date)){
        // If Today is after the freeze period
        let freeze_start = new Date(vehicle.freeze_start_date);
        let freeze_end = new Date(vehicle.freeze_end_date);

        offset =  getMonthsBetween(freeze_start, freeze_end); // work out how many months it was frozen for and offset total by this amount
      }
      let monthsBetween = getMonthsBetween(date, finalPayment);
      monthsBetween = monthsBetween + offset;

      const monthlies = Math.min(monthsBetween, vehicle.payment_term) * vehicle.monthly_payment;

      return monthlies.toFixed(2);

    } else if (vehicle.finance_type === "FIXED_MONTHLY_CAPITAL") {
      const paymentSchedule = getPaymentSchedule(vehicle);
      const remainingPayments = getRemainingPayments(paymentSchedule, date);
      const monthly_payment = vehicle.monthly_payment * 1;
      const balloon_payment = vehicle.balloon_payment * 1;

      const outstandingBalance = (
        remainingPayments.length * monthly_payment +
        getFlatInterestRemaining(vehicle, date, finalPayment) +
        (vehicle.finance_type === "STOCKING_PLAN" ? balloon_payment : 0)
      );

      return outstandingBalance ? outstandingBalance : 0;
    } else if (vehicle.finance_type === "STOCKING_PLAN") {
      const paymentSchedule = getPaymentSchedule(vehicle);
      const remainingPayments = getRemainingPayments(paymentSchedule, date);

      const remainingInterest = remainingPayments.reduce((prev, next) => ({interest_accrued: prev.interest_accrued + next.interest_accrued}), {interest_accrued: 0}).interest_accrued || 0
      const remainingCapital = remainingPayments.reduce((prev, next) => ({capital_payment: prev.capital_payment + next.capital_payment}), {capital_payment: 0}).capital_payment || 0

      let balloonValue = (vehicle.balloon_payment_date && new Date(vehicle.balloon_payment_date) < date)

      const outstandingBalance = remainingInterest + remainingCapital + vehicle.balloon_payment;

      return outstandingBalance ? Math.round(outstandingBalance * 100 + Number.EPSILON) / 100 : 0;
    }
  } else {
    return 0;
  }
};

export const getMonthsBetween = (a, b) => {
  if (!a || !b) {
    return 0;
  }
  let months;
  months = (b.getFullYear() - a.getFullYear()) * 12;
  months -= a.getMonth();
  months += b.getMonth();

  let today = a.getDate();
  let finalPaymentDay = b.getDate();

  if (today <= finalPaymentDay) {
    months += 1;
  }

  return months;
};

export const  weeksBetween = (d1, d2) => {
    d1 = new Date(d1);
    d2 = new Date(d2);
    return Math.round((d2 - d1) / (7 * 24 * 60 * 60 * 1000));
}

export const getFreePeriodMonths = (a, b) => {
  let dateA, dateB;
  if (!a || !b) {
    return 0;
  }
  try {
    dateA = new Date(a);
    dateB = new Date(b);
  } catch {
    return 0;
  }

  let months;
  months = (dateB.getFullYear() - dateA.getFullYear()) * 12;
  months -= dateA.getMonth();
  months += dateB.getMonth();

  let today = dateA.getDate();
  let finalPaymentDay = dateB.getDate();

  if (today <= finalPaymentDay) {
    months += 1;
  }

  months -= 1;

  return months > 0 ? months : 0;
}

export const getMonthsBetweenFormDates = (a, b) => {
  let dateA, dateB;
  if (!a || !b) {
    return 0;
  }
  try {
    dateA = new Date(a);
    dateB = new Date(b);
  } catch {
    return 0;
  }
  return getMonthsBetween(dateA, dateB)
}

export const getDaysBetween = (a, b) => {
  // The number of milliseconds in all UTC days (no DST)
  const oneDay = 1000 * 60 * 60 * 24;

  // A day in UTC always lasts 24 hours (unlike in other time formats)
  const start = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  const end = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

  // so it's safe to divide by 24 hours
  return (end - start) / oneDay;
};

export const getEstimatedValue = vehicle => {
  if (!vehicle.internal_sale_date) {
    let now = new Date(Date.now());
    return getEstimatedValueForDate(vehicle, now);
  } else {
    return getInternalSalePrice(vehicle);
  }
};

export const getEstimatedValueForDate = (vehicle, date) => {
  let purchaseDate = new Date(vehicle.depreciation_start_date);

  if(vehicle.freeze_start_date && vehicle.freeze_end_date){

    let freeze_start = new Date(vehicle.freeze_start_date);
    let freeze_end = new Date(vehicle.freeze_end_date);

    // UTC dates are not affected by day light savings so they will more more accurate
    let utcFreezeStart = Date.UTC(freeze_start.getFullYear(), freeze_start.getMonth(), freeze_start.getDate());
    let utcFreezeEnd = Date.UTC(freeze_end.getFullYear(), freeze_end.getMonth(), freeze_end.getDate());

    const msPerDay = 1000 * 60 * 60 * 24 //Milliseconds in a day

    if(freeze_start <= date && date <= freeze_end){
      // If in the freeze period
      // set date to day before freeze start
      date = freeze_start
      date.setDate(freeze_start.getDate() - 1);
    }
    else if(date > freeze_end){
      let freeze_dif = Math.floor((utcFreezeEnd - utcFreezeStart) / msPerDay);
      // If after freeze period
      // set date to date - difference in freeze
      date.setDate(date.getDate() - freeze_dif);
    }
  }
  let days = getDaysBetween(purchaseDate, date);
  const daily_depreciation_rate =
    1 - Math.pow(1 - vehicle.annual_depreciation_rate / 100, 1 / 365);
  let estimatedValue = vehicle.purchase_price * Math.pow(1 - daily_depreciation_rate, days);

  return estimatedValue;
};

export const getInternalSalePrice = vehicle => {
  if (vehicle.internal_sale_date) {
    const saleDate = new Date(vehicle.internal_sale_date);
    return getEstimatedValueForDate(vehicle, saleDate);
  } else {
    return 0;
  }
};

export const formatCurrency = num => {
  return (
    "£" + roundCurrency(num)
  );
};

export const roundCurrency = num => {
  return (
    parseFloat(num || 0).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
  );
}

export const getHpInterestRate = vehicle => {
  if (
    vehicle.payment_term &&
    vehicle.monthly_payment &&
    vehicle.finance_amount_borrowed &&
      (vehicle.finance_type === "REGULAR" || vehicle.finance_type === "LEASE_AGREEMENT")
  ) {
    return (
      rate(
        1 * vehicle.payment_term,
        -1 * vehicle.monthly_payment,
        1 * vehicle.finance_amount_borrowed || 0
      ) *
      12 *
      100
    ).toFixed(5);
  } else {
    return parseFloat(vehicle.hp_interest_rate) || 0;
  }
};

export const rate = (nper, pmt, pv, fv, type, guess) => {
  // Sets default values for missing parameters
  fv = typeof fv !== "undefined" ? fv : 0;
  type = typeof type !== "undefined" ? type : 0;
  guess = typeof guess !== "undefined" ? guess : 0.1;

  // Sets the limits for possible guesses to any
  // number between 0% and 100%
  var lowLimit = 0;
  var highLimit = 1;

  // Defines a tolerance of up to +/- 0.00005% of pmt, to accept
  // the solution as valid.
  var tolerance = Math.abs(0.00000005 * pmt);

  // Tries at most 40 times to find a solution within the tolerance.
  for (var i = 0; i < 40; i++) {
    // Resets the balance to the original pv.
    var balance = pv;

    // Calculates the balance at the end of the loan, based
    // on loan conditions.
    for (var j = 0; j < nper; j++) {
      if (type == 0) {
        // Interests applied before payment
        balance = balance * (1 + guess) + pmt;
      } else {
        // Payments applied before insterests
        balance = (balance + pmt) * (1 + guess);
      }
    }

    // Returns the guess if balance is within tolerance.  If not, adjusts
    // the limits and starts with a new guess.
    if (Math.abs(balance + fv) < tolerance) {
      return guess;
    } else if (balance + fv > 0) {
      // Sets a new highLimit knowing that
      // the current guess was too big.
      highLimit = guess;
    } else {
      // Sets a new lowLimit knowing that
      // the current guess was too small.
      lowLimit = guess;
    }

    // Calculates the new guess.
    guess = (highLimit + lowLimit) / 2;
  }

  // Returns null if no acceptable result was found after 40 tries.
  return null;
};

export const getWorkTotals = (work, labourFieldName, partFieldName) => {
  return work.reduce(
    (sum, curr) => {
      return {
        [labourFieldName]: 1 * sum[labourFieldName] + 1 * curr[labourFieldName],
        [partFieldName]:
        1 * sum[partFieldName] +
        curr.parts.reduce((partsSum, currentPart) => {
          return 1 * partsSum + 1 * currentPart[partFieldName];
        }, 0)
      };
    },
    {[labourFieldName]: 0, [partFieldName]: 0}
  );
};
export function fixDates(item, dateFields){
  dateFields.forEach((field) => {
    if(item[field] === ""){
      item[field] = null;
    }
  })
  return item
}
export const fixEmptyDatesNotJob = (object, dateFields) => {
  dateFields.forEach(function (date) {
      if (object[date] === "") {
        object[date] = null;
      }
    });
  return object;
}
export const fixEmptyDates = (job, dateFields) => {
    dateFields.forEach(function (date) {
      if (job[date] === "") {
        job[date] = null;
      }
    });
    let work_items = job.work_items;
    job.work_items = work_items.map(work => {
      let parts = work.parts;
      work.parts = parts.map(part => {
        if (part.date_ordered === "") {
          part.date_ordered = null;
        }
        if (part.backorder_expected_date === "") {
          part.backorder_expected_date = null;
        }
        return part;
      });
      return work;
    });
    return job;
};
export const addVat = (amount) => {
      return amount*1.2;
}
export const fixEmptyDepartment = (job) => {
    if (!job.department){
      job.department = {name: "Rentals Direct", id:1};
    }
    return job;
};

export const validateInvoiceNumber = (inv_no_to_test) => {
  const validText = ['warranty', 'cash sale', 'rd', 'nr']

  if (!inv_no_to_test || inv_no_to_test.length < 1) {
    return false;
  } else {
    let invoice_number = inv_no_to_test.toLowerCase();
    return validText.some(function (v) {
      return invoice_number.indexOf(v) >= 0;
    }) || !/[A-Za-z]+/.test(inv_no_to_test)
  }
}
export const validateBeforeApproval = (work, view) => {
    if (view === "invoice") {
        if(work.chargeable_customer_complete) {
          let isValid = true;
          // The work and all associated parts must have a nominal code
          if(work.customer_nominal_code && work.customer_nominal_code.id && work.customer_invoice_date){
            //Check all associated parts fpr a nominal code
            work.parts.forEach(part => {
              if(!part.customer_nominal_code){
                NotificationManager.warning("All parts need a nominal code");
                isValid = false;
              }
            });

          }
          else{
            NotificationManager.warning("All work items need a nominal code and invoice date")
            isValid = false;
          }
          // if (work.chargeable) {
          //   isValid = isValid && work.job_customer2_invoice_number
          // } else if (!(work.chargeable)) {
          //   isValid = isValid && work.job_customer_invoice_number
          // }
          return isValid
        } else {
          NotificationManager.warning("The chargeable customer must be set up completly");
          return false
        }
    } else if (view === "po") {
      if(!(compareVat(work.supplier_nominal_code, work.labour_cost_vat))){
        NotificationManager.warning("Vat entered does not match nominal vat")
      }
      if (work.work_type) {
        //if (work.supplier_nominal_code && work.supplier_nominal_code.id) {
        let valid = true;
        if (work.work_type.approval_needed) {
          if (!work.approval_received) {
            valid = false
            NotificationManager.warning("Missing Approval")
          }
        } else if (work.work_type.free_of_charge) {
          return true
        }
        if (!(work.job_workshop_invoice_number && work.job_workshop_invoice_number.length > 0)) {
          valid = false;
        }
        if(!(!!work.workshop_invoice_date)){
            valid = false;
        }
        if(!(!!work.supplier_nominal_code)){
          valid = false;
        }

        work.parts.forEach(part => {
          if(!(!!part.supplier_nominal_code)){
            valid=false
          }
        })

        if (valid === false) {
          NotificationManager.warning("Missing valid workshop invoice number, invoice date and/or payment date and Nominal Codes")
        }
        return valid
        //} else {
        //    NotificationManager.warning("Nominal Code is required")
        //}
      } else {
        NotificationManager.warning("Work Type is required")
      }
    }
    return false;
};

export const onFileChange = (e, fileList, setFileList) =>{
  let files = e.target.files;
  let dataTransfer = new DataTransfer();
  if(fileList && fileList.length) {
    for (let i = 0; i < fileList.length; i++) {
      dataTransfer.items.add(fileList[i]);
    }
  }
  for(let i=0; i<files.length;i++){
    dataTransfer.items.add(files[i]);
  }
  setFileList(dataTransfer.files);
}
const upload = async function (file, res) {
    const url = res['url'];
    if (url) {
      if(file.type !== 'image/png' && file.type !== 'image/jpeg' && file.type !== 'application/pdf'){
        NotificationManager.error("Not supported file format");
        return new Promise((resolve, reject) => {reject("Not supported File format")});
      }
      const urlToUse = url[file.type]

      const conf = {
        headers: {
          "Content-Type": file.type,
          "Content-Disposition": "inline"
        },
        method: "put",
        url: urlToUse,
        data: file
      }

      // axios(conf).then(uploadResponse => {
      //  if (uploadResponse.ok) {
      //    NotificationManager.success("Image uploaded successfully");
      //    return new Promise((resolve, reject) => {resolve(true)});
      //  } else {
      //    NotificationManager.error("Failed to upload the file to the signed URL");
      //    return new Promise((resolve, reject) => {reject("Failed to upload")});
      //  }
      // })

      //  SHOULD BE USING AXIOS
      const uploadResponse = await fetch(urlToUse, {
       method: "PUT",
       headers: {
         "Content-Type": file.type,
         "Content-Disposition": "inline",
       },
       body: file, // the file blob
      });
      if (uploadResponse.ok) {
         NotificationManager.success("Image uploaded successfully");
         return new Promise((resolve, reject) => {resolve(true)});
       } else {
         NotificationManager.error("Failed to upload the file to the signed URL");
         return new Promise((resolve, reject) => {reject("Failed to upload")});
       }

    }
    else{
      NotificationManager.warning("Upload url could not be found");
      return new Promise((resolve, reject) => {reject("No URL found")});
    }
}
export const triggerUpload = (files, jobId, selectedVehicle, setFileList, deleteImage, dataFresh, dispatch, type) => {
  if(selectedVehicle) {
    if (files) {
      const promises = []
      let urls = []
      for (let i=0;i<files.length; i++){
          urls.push(axios.get('/api/uploadimage?reg=' + selectedVehicle.registration + "&id=" + jobId+"&type="+type+"&file_type="+files[i].type))
      }
      Promise.all(urls).then(urls =>{
          urls.forEach((url, index) => {
              promises.push(upload(files[index], url.data).catch((err) => {
                  deleteImage(url.data['image'])
                  NotificationManager.error("Image did not successfully upload");
              }));
          });
          Promise.all(promises).then(res => {
              setFileList(undefined);
              dispatch(createSetDataFreshAction(dataFresh + 1));
          })
      });
    }
  }
  else{
    NotificationManager.error("No vehicle selected");
  }
}

export function hasApprovedWork(job, approveField){
  let return_data = false
  if(job){
    job.work_items.forEach(work => {
      if(work[approveField]){
        return_data = true;
      }
    })
  }
  return return_data;
}

export function movementCost(movement){
  if(movement.miles && movement.movement_rate && !movement.cost_override){
    let upfrontCost = parseFloat(movement.movement_rate.additional_time_cost) + parseFloat(movement.movement_rate.vehicle_cost) + parseFloat(movement.movement_rate.callout_cost);
    let mileCost = 0;
    if(movement.customer && movement.customer.movement_markup !== 0){
      mileCost = parseFloat(movement.miles) * (parseFloat(movement.movement_rate.cost_per_mile) * (parseFloat(movement.customer.movement_markup) / 100));
    }
    else{
      mileCost = parseFloat(movement.miles) * parseFloat(movement.movement_rate.cost_per_mile);
    }
    movement.cost = (parseFloat(upfrontCost + mileCost)).toFixed(2);
  }
  if(movement.miles && movement.movement_rate && !movement.supplier_cost_override){
    let upfrontCost = parseFloat(movement.movement_rate.supplier_one_off_charge);
    let mileCost = parseFloat(movement.miles) * parseFloat(movement.movement_rate.supplier_cost_per_mile);
    movement.internal_charge = (parseFloat(upfrontCost + mileCost)).toFixed(2);
  }
  if(movement.miles && movement.movement_rate && !movement.external_supplier_charge_override){
    let upfrontCost = parseFloat(movement.movement_rate.external_one_off_charge);
    let mileCost = parseFloat(movement.miles) * parseFloat(movement.movement_rate.external_cost_per_mile);
    movement.external_supplier_charge = (parseFloat(upfrontCost + mileCost)).toFixed(2);
  }
  return movement;
}

function getDateFromDate(date, days){
  // Takes a date object date and an int days
  // returns a new date object days ahead of given date
  let newDate = date;
  newDate.setDate(newDate.getDate() + days);
  return newDate
}

export function expenseDueDate(expense, dateField, contactField){

  let supplier = expense[contactField];
  let invoiceDate = new Date(expense[dateField]);

  if(supplier) {
    if (supplier.supplier_payment_terms_start === "DATE") {
      if (expense[dateField]) {
        return getDateFromDate(invoiceDate, supplier.supplier_payment_terms)
      }
    } else if (supplier.supplier_payment_terms_start === "MONTH") {
      if (expense[dateField]) {
        let endOfMonth = new Date(invoiceDate.getFullYear(), invoiceDate.getMonth() + 1, 0);
        return getDateFromDate(endOfMonth, supplier.supplier_payment_terms)
      }

    }
  }
}

export const getPhoneNumber = (contact) => {
    let returnString = "";
    if(contact.company_phone_type === "Phone"){
      returnString+=contact.company_phone_area_code+" ";
    }
    else if(contact.company_phone_type === "Mobile"){
      // Does not need space at end as county code followed by phone number with no spaces is standard e.g. (+44XXXXXXXXXX)
      returnString+=contact.company_phone_country_code
    }
    // Fax type just uses phone number field
    returnString+=contact.company_phone;

    return returnString;
}